<template>
  <modal class="modal cloudapp-modal narrow" id="signup-modal" :hide-footer="true" :hide-header="true">
    <div class="d-flex">
      <div id="left-wrapper">
        <div id="header">
          <img
            src="@img/cloudapp.png"
            width="180"
            height="41"
            class="logo"
            alt="CloudApp Logo"
          />
        </div>
        <div id="body">
          <div class="mb-4">
            <h1 class="h4 text-center">Get started</h1>
          </div>
          <a
            :href="googleIdUrl"
            class="btn d-flex justify-content-center align-items-center google-login-button btn-block btn-auth"
          >
            <img
              width="18"
              height="18"
              src="@img/icon-google.svg"
              class="mr-2"
            />
            <span>Sign up with Google</span>
          </a>

          <a
            :href="appleIdUrl"
            class="btn d-flex justify-content-center align-items-center google-login-button btn-block btn-auth"
          >
            <img
              width="18"
              height="18"
              src="@img/apple_logo.svg"
              class="mr-2"
            />
            <span>Sign up with Apple</span>
          </a>

          <a
            v-if="showSlackButton"
            :href="slackIdUrl"
            class="btn d-flex justify-content-center align-items-center google-login-button btn-block btn-auth"
          >
            <img
              width="18"
              height="18"
              src="@img/slack_logo.svg"
              class="mr-2"
            >
            <span>Sign up with Slack</span>
          </a>
          <p class="my-4 text-center divider-label">
            <small class="text-muted">or sign up with email</small>
          </p>
          <form id="modal-signup-form" data-type="json" :action="formAction" accept-charset="UTF-8" data-remote="true" method="post">
            <div class="form-group">
              <label for="email">Work Email</label>
              <input type="email" name="email" id="email" required="required" class="form-control" v-model="email" @keydown.stop>
            </div>
            <div class="form-group">
              <label for="password">Password</label>
              <input
                type="password"
                name="password"
                id="password"
                required="required"
                autocomplete="off"
                class="form-control"
                @keydown.stop
              >
              <small
                id="text-password-requirements"
                class="form-text text-muted"
              >
                Must be at least 8 characters long, contain uppercase letters and a number.
              </small>
            </div>
            <ul class="error-notification errors text-danger"></ul>
            <div class="text-center">
              <input
                type="submit"
                name="commit"
                value="Sign up"
                data-disable-with="Create my account"
                class="btn-primary btn btn-block identifyUser create-account"
              >
            </div>
            <div class="modal-footer text-center">
              <nav aria-label="Secondary navigation">
                <ul class="list-unstyled text-sm text-center">
                  <li><a href="/sso/new?utm_campaign=signup_modal&utm_source=viewer">Sign up with SSO</a></li>
                  <li>
                    Have an account?
                    <a
                      href="#"
                      @click="openLoginModal"
                      data-testid="login-link"
                    >
                      Sign in
                    </a>
                  </li>
                </ul>
              </nav>
            </div>
          </form>
        </div>
      </div>
      <div id="cloudapp-description-wrapper">
        <div class="cloudapp-description-text">Create videos, GIFs, annotated screenshots and share instantly</div>
      </div>
    </div>
  </modal>
</template>

<script>
import Modal from "@cmp/modal.vue";
import { modalsUser } from "@/src/observable";
import { mapState } from 'vuex';
import featureKey from "../feature_key.macro";

export default {
  components: { Modal },
  props: {
    returnTo: { type: String, default: window.location.href },
  },
  methods: {
    openLoginModal: function(){
      this.$bvModal.show('login-modal');
      this.$bvModal.hide('signup-modal');
    },
  },
  computed: {
    ...mapState({
      showSlackSignButton: state => state.features?.[featureKey("web-show-slack-sign-button")],
    }),
    email: {
      set: function(val){ modalsUser.email = val },
      get: function(){ return modalsUser.email }
    },
    formAction: function(){
      return `/api/v4/account?utm_source=viewer&utm_medium=nav_button_image&utm_content=drop:${this.$route.params.slug}`
    },
    showSlackButton : function(){
      return this.showSlackSignButton;
    },
    appleIdUrl:  function() { return `/auth/apple?web=true&return_to=${this.returnTo}` },
    slackIdUrl:  function() { return `/auth/slack?web=true&return_to=${this.returnTo}` },
    googleIdUrl: function () { return `/auth/google?web=true&return_to=${this.returnTo}` }
  }
}
</script>

<style lang="scss">
  @import "application.scss";

  #signup-modal___BV_modal_outer_ {
    .modal-dialog { max-width: 660px;}
    .modal-content {
      overflow: hidden;
      border-radius: 10px;
      border: 0 none;
    }
    .modal-body { padding: 0; }
    .modal-footer {
      display: flex;
      flex-direction: column;
    }

    #header {
      background: white;
      font-size: 24px;
      font-weight: 600;
      display: flex;
      align-items: center;
      padding: 20px;
      padding-bottom: 0;
    }

    #header .logo {
      margin: 0 auto;
    }


    #left-wrapper {
      background: var(--white);
      // max-width: 380px;
      padding: 1rem;

      @media screen and (min-width: 400px) {
        padding: 1rem 2rem;
      }

      #body {
        padding: 0 20px
      }

      form {
        label {
          font-size: 12px;
          font-weight: 600;
        }
      }

      .create-account {
        margin: 14px 0;
      }
    }

    #cloudapp-description-wrapper {
      display: flex;
      max-width: 300px;
      flex-direction: column;
      justify-content: center;
      background-color: var(--primary);
      padding: 20px;
      border-radius: 10px;
      margin: 10px;

      .cloudapp-description-text {
        color: var(--white);
        font-size: 30px;
        font-weight: 500;
        text-align: left;
        margin-top: 40px;
        margin-bottom: 60px;
      }
    }

    @media screen and (max-width:650px){
      #cloudapp-description-wrapper{
        display:none;
      }
      #left-wrapper{
        width: 100%;
      }
    }
  }
  .btn-auth {
    border: 1px solid #d8d8d8;
    border-radius: 8px;
    padding: .9rem 1.5rem .9rem !important;
    font-size: .9rem !important;
    font-weight: 600;
  }
  .btn-auth:hover {
    background-color: #eee;
  }
</style>
